import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/userProfileReducer";
import rootSaga from "./redux/userProfileSagas";
import UserProfileModule from "./userProfileModule";
import ErrorBoundary from "../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../utils/createReduxStore";

const UserProfilePage = ({ notifications = {} }) => (
  <Provider store={createReduxStore(reducer, "userProfile", rootSaga)}>
    <ErrorBoundary moduleName="userProfile" {...notifications}>
      <UserProfileModule />
    </ErrorBoundary>
  </Provider>
);

export default UserProfilePage;
